<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
@if (errorWhileInitializing()) {
  <div>
    <profile-pds-p-text p-text size="md" align="center">{{ 'pidpaw.generic.error.initialisation' | translate }} </profile-pds-p-text>
  </div>
}

@if (!errorWhileInitializing()) {
  @if (isLoading()) {
    @if (announceLoading()) {
      <span class="profile:sr-only" role="status" aria-live="polite" aria-atomic="true">
        {{ 'birthdayWidget.general.loadingStatus' | translate }}
      </span>
    }
    @if (mode === MyProfileBirthdayWidgetMode.PROFILE) {
      <pidx-skeleton-loader></pidx-skeleton-loader>
    }
    @if (mode !== MyProfileBirthdayWidgetMode.PROFILE) {
      <div class="profile:h-75 profile:max-h-screen profile:flex profile:justify-center">
        <profile-pds-p-spinner
          p-spinner
          [size]="{ base: 'sm', l: 'md' }"
          [attr.aria-label]="'pidpaw.generic.aria.loading' | translate"
          data-protractor-id="birthday-widget-app-loader"
        ></profile-pds-p-spinner>
      </div>
    }
  } @else {
    <div class="profile:pb-fluid-sm profile:flex profile:flex-col profile:md:flex-row">
      @if (mode === MyProfileBirthdayWidgetMode.PROFILE) {
        <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm">
          <profile-pds-p-text p-text size="sm" color="contrast-medium">
            <div id="birthday-title" [innerHTML]="'birthdayWidget.birthday.title' | translate"></div>
          </profile-pds-p-text>
        </div>
      }
      <div [ngClass]="mode === MyProfileBirthdayWidgetMode.PROFILE ? 'profile:w-full profile:md:w-3/4' : 'profile:w-full'">
        @if (fetchDateOfBirthRequestErrorResponse()) {
          <pidx-inline-form-messages [messages]="[fetchDateOfBirthRequestErrorResponse() | translate]"></pidx-inline-form-messages>
        }
        <div class="profile:mt-fluid-md profile:md:mt-0">
          @if (!isEditMode()) {
            <myprofile-birthday-display
              [mode]="mode"
              [formattedDate]="formattedDate()"
              (editBirthday)="setEditMode(true, $event)"
              (deleteBirthday)="triggerDelete()"
              [noDateLabel]="'birthdayWidget.noDate.label' | translate"
              [editButtonLabel]="'birthdayWidget.button.edit.label' | translate"
              [deleteButtonLabel]="'birthdayWidget.button.delete.label' | translate"
              [isCnUser]="isCnUser()"
              [restrictGlobalUIChanges]="restrictGlobalUIChanges"
            ></myprofile-birthday-display>
          }
          @if (isEditMode()) {
            <myprofile-birthday-editform
              [dateToEdit]="dateToEdit()"
              [minDate]="minDate()"
              [maxDate]="maxDate()"
              [errorMessage]="errorMessage()"
              (cancelBirthday)="setEditMode(false)"
              (saveBirthday)="triggerSave($event)"
            ></myprofile-birthday-editform>
          }
        </div>
      </div>
    </div>
    @if (!formattedDate() && !isEditMode()) {
      <div class="profile:mt-fluid-md">
        @if (mode === MyProfileBirthdayWidgetMode.PROFILE) {
          <div class="profile:flex profile:flex-col profile:md:flex-row">
            <div class="profile:w-full profile:md:w-1/4 profile:md:pe-static-sm"></div>
            <div class="profile:w-full profile:md:w-3/4">
              <profile-pds-p-button
                p-button
                id="addBirthdateBtn"
                data-protractor-id="birthday-widget-add-dob-button"
                [attr.aria-describedby]="'birthday-no-date-hint'"
                (click)="setEditMode(true, 'addBirthdateBtn')"
                variant="secondary"
                icon="plus"
                [myprofileUiTrack]="{
                  clickElementType: 'button',
                  clickElementId: 'date_of_birth',
                  clickElementName: 'add',
                }"
                >{{ 'birthdayWidget.button.add.label' | translate }}
              </profile-pds-p-button>
            </div>
          </div>
        }
        @if (mode !== MyProfileBirthdayWidgetMode.PROFILE) {
          @if (!isCnUser() || (isCnUser() && !restrictGlobalUIChanges)) {
            <div>
              <profile-pds-p-button-pure
                p-button-pure
                [attr.aria-describedby]="'birthday-no-date-hint'"
                (click)="setEditMode(true, 'addBirthdateBtn')"
                id="addBirthdateBtn"
                data-protractor-id="birthday-widget-add-dob-button"
                icon="plus"
                [myprofileUiTrack]="{
                  clickElementType: 'button',
                  clickElementId: 'date_of_birth',
                  clickElementName: 'add',
                }"
                >{{ 'birthdayWidget.button.add.label' | translate }}
              </profile-pds-p-button-pure>
            </div>
          }
        }
      </div>
    }
    <!-- START ~~ OVERLAY LOADER, CONTENT VISIBLE AS WELL AS LOADER OVERLAY -->
    @if (isRefreshing()) {
      <pidx-loader [mode]="PidxLoaderModeEnum.INLINE" [loadingLabel]="'birthdayWidget.general.savingStatus' | translate"></pidx-loader>
    }
    <!-- END ~~ OVERLAY LOADER -->
  }
}
